<template>
  <CHeader position="sticky" class="app-header">
    <CContainer fluid class="header-container">
      <div class="header-bar">
        <CHeaderBrand class="header-brand" to="/">
          <router-link to="/home" @click="closeMobileMenu">
            <img
              alt="The Factory HKA Venezuela"
              src="@/assets/images/tfhka-ve.webp"
              height="68"
              width="160"
            />
          </router-link>
        </CHeaderBrand>

        <button
          type="button"
          class="mobile-menu-toggle"
          :aria-expanded="mobileMenuOpen"
          aria-controls="mobile-header-nav"
          aria-label="Abrir menú de navegación"
          @click="toggleMobileMenu"
        >
          <span
            class="mobile-menu-toggle__icon"
            :class="{ 'mobile-menu-toggle__icon--open': mobileMenuOpen }"
            aria-hidden="true"
          ></span>
        </button>
      </div>

      <CHeaderNav class="justify-content-end header-nav header-nav-desktop">
        <template v-if="mainmenus.length">
          <div
            v-for="mainmenu in mainmenus"
            :key="mainmenu.id"
            class="nav-menu-item"
          >
            <CNavItem v-if="mainmenu.menu === null">
              <router-link
                v-if="mainmenu.url_type_id === '1'"
                target="_self"
                :to="'/' + mainmenu.url"
                class="nav-link"
              >
                <strong>{{ mainmenu.name }}</strong>
              </router-link>
              <a
                v-else-if="mainmenu.url_type_id === '2'"
                :href="mainmenu.url"
                class="nav-link promotion"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>{{ mainmenu.name }}</strong>
                <CBadge color="danger">Nuevo</CBadge>
              </a>
              <router-link
                v-else-if="mainmenu.url_type_id === '3'"
                :to="'/' + mainmenu.url"
                class="nav-link promotion"
              >
                <strong>{{ mainmenu.name }}</strong>
                <CBadge color="danger">Nuevo</CBadge>
              </router-link>
            </CNavItem>
            <CDropdown v-if="mainmenu.menu !== null" variant="nav-item">
              <CDropdownToggle href="javascript:void(0);" color="secondary">
                <strong>{{ mainmenu.name }}</strong>
              </CDropdownToggle>
              <CDropdownMenu class="dropdown-fade-in">
                <CDropdownItem
                  v-for="submenu in mainmenu.menu"
                  :key="submenu.id"
                >
                  <router-link :to="'/' + submenu.url">
                    {{ submenu.name }}
                  </router-link>
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </div>
        </template>
        <template v-else>
          <CNavItem
            v-for="n in 7"
            :key="'nav-skeleton-' + n"
            class="nav-skeleton"
            aria-hidden="true"
          >
            <span class="nav-link skeleton-nav-link">&nbsp;</span>
          </CNavItem>
        </template>
        <ul class="nav navbar-nav navbar-right">
          <li>
            <CDropdown variant="nav-item" class="dropdown profile hidden-xs">
              <CDropdownToggle href="javascript:void(0);" color="secondary">
                <img
                  width="35"
                  height="35"
                  min-width="35px"
                  src="@/assets/images/country/Venezuela.webp"
                  alt="The Factory HKA Venezuela"
                />
              </CDropdownToggle>
              <CDropdownMenu
                class="dropdown-menu dropdown-contry dropdown-fade-in text-center center-block"
              >
                <CRow>
                  <CCol v-for="country in countries" :key="country.href" sm="6">
                    <CDropdownItem :href="country.href">
                      <img :alt="country.alt" :src="country.img" />
                      {{ country.label }}
                    </CDropdownItem>
                    <li class="divider"></li>
                  </CCol>
                </CRow>
              </CDropdownMenu>
            </CDropdown>
          </li>
        </ul>
      </CHeaderNav>

      <nav
        v-show="mobileMenuOpen"
        id="mobile-header-nav"
        class="mobile-nav-panel"
        aria-label="Menú principal"
      >
        <template v-if="mainmenus.length">
          <div
            v-for="mainmenu in mainmenus"
            :key="'mobile-' + mainmenu.id"
            class="mobile-nav-group"
          >
            <template v-if="mainmenu.menu === null">
              <router-link
                v-if="mainmenu.url_type_id === '1'"
                :to="'/' + mainmenu.url"
                class="mobile-nav-link"
                @click="closeMobileMenu"
              >
                {{ mainmenu.name }}
              </router-link>
              <a
                v-else-if="mainmenu.url_type_id === '2'"
                :href="mainmenu.url"
                class="mobile-nav-link"
                target="_blank"
                rel="noopener noreferrer"
                @click="closeMobileMenu"
              >
                {{ mainmenu.name }}
                <CBadge color="danger">Nuevo</CBadge>
              </a>
              <router-link
                v-else-if="mainmenu.url_type_id === '3'"
                :to="'/' + mainmenu.url"
                class="mobile-nav-link"
                @click="closeMobileMenu"
              >
                {{ mainmenu.name }}
                <CBadge color="danger">Nuevo</CBadge>
              </router-link>
            </template>

            <template v-else>
              <button
                type="button"
                class="mobile-nav-toggle"
                :aria-expanded="isMobileSubmenuOpen(mainmenu.id)"
                @click="toggleMobileSubmenu(mainmenu.id)"
              >
                <span>{{ mainmenu.name }}</span>
                <span
                  class="mobile-nav-chevron"
                  :class="{
                    'mobile-nav-chevron--open': isMobileSubmenuOpen(
                      mainmenu.id,
                    ),
                  }"
                  aria-hidden="true"
                ></span>
              </button>
              <div
                v-show="isMobileSubmenuOpen(mainmenu.id)"
                class="mobile-submenu"
              >
                <router-link
                  v-for="submenu in mainmenu.menu"
                  :key="submenu.id"
                  :to="'/' + submenu.url"
                  class="mobile-nav-sublink"
                  @click="closeMobileMenu"
                >
                  {{ submenu.name }}
                </router-link>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div
            v-for="n in 6"
            :key="'mobile-skeleton-' + n"
            class="mobile-nav-link mobile-nav-link--skeleton"
            aria-hidden="true"
          ></div>
        </template>

        <div class="mobile-nav-countries">
          <p class="mobile-nav-countries__title">Seleccionar país</p>
          <a
            v-for="country in countries"
            :key="'mobile-country-' + country.href"
            :href="country.href"
            class="mobile-country-link"
            @click="closeMobileMenu"
          >
            <img :alt="country.alt" :src="country.img" width="24" height="24" />
            <span>{{ country.label }}</span>
          </a>
        </div>
      </nav>
    </CContainer>
  </CHeader>
</template>

<script>
const COUNTRIES = [
  {
    href: 'http://www.thefactoryhka.com/ve/',
    alt: 'Venezuela',
    img: require('@/assets/images/country/Venezuela.webp'),
    label: 'Venezuela',
  },
  {
    href: 'http://www.thefactoryhka.com/mx/',
    alt: 'Mexico',
    img: require('@/assets/images/country/Mexico.webp'),
    label: 'México',
  },
  {
    href: 'http://www.thefactoryhka.com/co/',
    alt: 'Colombia',
    img: require('@/assets/images/country/Colombia.webp'),
    label: 'Colombia',
  },
  {
    href: 'http://www.thefactoryhka.com.do',
    alt: 'Dominicana',
    img: require('@/assets/images/country/Dominican-Republic.webp'),
    label: 'R. Dominicana',
  },
  {
    href: 'http://www.thefactoryhka.com/pa/',
    alt: 'Panama',
    img: require('@/assets/images/country/Panama.webp'),
    label: 'Panamá',
  },
  {
    href: 'http://www.thefactoryhka.com/pe/',
    alt: 'Peru',
    img: require('@/assets/images/country/Peru.webp'),
    label: 'Perú',
  },
  {
    href: 'http://www.thefactoryhka.com/bo/',
    alt: 'Bolivia',
    img: require('@/assets/images/country/Bolivia.webp'),
    label: 'Bolivia',
  },
  {
    href: 'http://www.thefactoryhka.com/home',
    alt: 'Usa',
    img: require('@/assets/images/country/Usa.webp'),
    label: 'USA',
  },
]

export default {
  name: 'AppHeader',
  data() {
    return {
      mainmenus: [],
      mobileMenuOpen: false,
      expandedMobileMenus: {},
      countries: COUNTRIES,
    }
  },
  watch: {
    $route() {
      this.closeMobileMenu()
    },
  },
  created() {
    const cached = this.$store.state.mainmenuItems
    if (cached?.value?.length) {
      this.mainmenus = JSON.parse(JSON.stringify(cached.value))
      this.$store.commit('updateMainmenu', true)
      return
    }

    let post = {
      country: this.$country,
    }
    let url = '/v1/menu/mainmenu'
    if (process.env.NODE_ENV != 'development') {
      url = `${location.protocol}//${location.hostname}${this.$api}${url}`
    }

    this.axios(url, {
      method: 'POST',
      mode: 'no-cors',
      data: post,
      withCredentials: true,
      headers: {
        Authorization: 'Basic ' + this.$token,
      },
      credentials: 'same-origin',
      crossdomain: true,
    })
      .then((resp) => {
        if (resp.data.result.approved === true) {
          this.mainmenus = resp.data.result.data
          this.$store.commit('updateMainmenuItems', {
            value: resp.data.result.data,
          })
          this.$store.commit('updateMainmenu', true)
        }
      })
      .catch((error) => {
        console.log(error)
        this.$store.commit('updateMainmenu', false)
      })
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      if (!this.mobileMenuOpen) {
        this.expandedMobileMenus = {}
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      this.expandedMobileMenus = {}
    },
    toggleMobileSubmenu(menuId) {
      this.expandedMobileMenus = {
        ...this.expandedMobileMenus,
        [menuId]: !this.expandedMobileMenus[menuId],
      }
    },
    isMobileSubmenuOpen(menuId) {
      return Boolean(this.expandedMobileMenus[menuId])
    },
  },
}
</script>
<style scoped>
.header-container {
  position: relative;
}

@media (min-width: 768px) {
  .header-container {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
  }

  .header-bar {
    flex: 0 0 auto;
    width: auto;
  }

  .header-nav-desktop {
    flex: 1 1 auto;
    min-width: 0;
    margin-left: auto;
    flex-wrap: nowrap !important;
    height: auto;
    min-height: 51px;
  }

  .header-nav-desktop :deep(.nav) {
    flex-wrap: nowrap;
    align-items: center;
  }

  .nav-menu-item {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
  }

  .header-nav-desktop :deep(.nav-link) {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    padding: 0.5rem 0.4rem;
  }

  .header-nav-desktop :deep(.nav-link strong) {
    font-weight: 600;
  }

  .header-nav-desktop :deep(.nav-link.promotion strong) {
    font-size: 0.95em;
  }

  .header-nav-desktop :deep(.badge) {
    flex-shrink: 0;
    font-size: 0.65em;
    vertical-align: middle;
  }

  .header-nav-desktop :deep(.navbar-right) {
    flex: 0 0 auto;
    margin-left: 4px;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .header-nav-desktop :deep(.nav-link) {
    font-size: 11px;
    padding: 0.5rem 0.25rem;
  }
}

.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.header-brand {
  margin: 0 !important;
}

.skeleton-nav-link {
  display: inline-block;
  min-width: 72px;
  height: 18px;
  background: #e8ecf1;
  border-radius: 4px;
  pointer-events: none;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.dropdown-fade-in {
  animation: fadeInRight 0.5s ease;
}

.mobile-menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid #d8dee9;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}

.mobile-menu-toggle__icon,
.mobile-menu-toggle__icon::before,
.mobile-menu-toggle__icon::after {
  display: block;
  width: 20px;
  height: 2px;
  background: #456bd9;
  border-radius: 2px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.mobile-menu-toggle__icon {
  position: relative;
}

.mobile-menu-toggle__icon::before,
.mobile-menu-toggle__icon::after {
  content: '';
  position: absolute;
  left: 0;
}

.mobile-menu-toggle__icon::before {
  top: -6px;
}

.mobile-menu-toggle__icon::after {
  top: 6px;
}

.mobile-menu-toggle__icon--open {
  background: transparent;
}

.mobile-menu-toggle__icon--open::before {
  top: 0;
  transform: rotate(45deg);
}

.mobile-menu-toggle__icon--open::after {
  top: 0;
  transform: rotate(-45deg);
}

.mobile-nav-panel {
  display: none;
}

@media (max-width: 767px) {
  .mobile-menu-toggle {
    display: inline-flex;
  }

  .header-nav-desktop {
    display: none !important;
  }

  .mobile-nav-panel {
    display: block;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 1030;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  }

  .mobile-nav-link,
  .mobile-nav-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 14px 16px;
    border: 0;
    border-bottom: 1px solid #f1f4f8;
    background: #fff;
    color: #1f2a44;
    font-size: 15px;
    font-weight: 600;
    text-align: left;
    text-decoration: none;
  }

  .mobile-nav-link--skeleton {
    min-height: 48px;
    background: linear-gradient(90deg, #e8ecf1 25%, #f4f6f8 50%, #e8ecf1 75%);
    background-size: 200% 100%;
    pointer-events: none;
  }

  .mobile-nav-chevron {
    width: 8px;
    height: 8px;
    border-right: 2px solid #456bd9;
    border-bottom: 2px solid #456bd9;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
  }

  .mobile-nav-chevron--open {
    transform: rotate(-135deg);
  }

  .mobile-submenu {
    background: #f8fafc;
  }

  .mobile-nav-sublink {
    display: block;
    padding: 12px 16px 12px 28px;
    border-bottom: 1px solid #eef2f7;
    color: #334155;
    font-size: 14px;
    text-decoration: none;
  }

  .mobile-nav-countries {
    padding: 12px 16px 16px;
    border-top: 1px solid #e8ecf1;
    background: #f8fafc;
  }

  .mobile-nav-countries__title {
    margin: 0 0 10px;
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .mobile-country-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    color: #1f2a44;
    font-size: 14px;
    text-decoration: none;
  }
}
</style>
